import { useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import "./apiScreen.css";
import { ApiI, ApiID, listaApis } from "./listaApis";
import { ApiEndpointI } from "./listaEndpointsPlanes";
import { EndpointsTable } from "./EndpointsTabla/EndpointsTable";
import { ImageIcon } from "assets/icons/ImageIcon";
import { DownloadFileIcon } from "assets/icons/DownloadFileIcon";
import { FileIcon } from "assets/icons/FileIcon";
import { Pagination } from "components/Pagination/Pagination";

export const ApiScreen = () => {
  const [currentApi, setCurrentApi] = useState<ApiI>();

  const [elementos, setElementos] = useState<ApiEndpointI[]>();
  const [page, setPage] = useState(1);

  const handleChangePage = ({
    page,
    limit,
  }: {
    [key: string]: string | number;
  }) => {
    if (!currentApi) return;
    const currentPage: number = Number(page);
    const currentLimit: number = Number(limit);
    const initialOffset = (currentPage - 1) * currentLimit;
    const finalOffset = currentLimit + initialOffset;
    setPage(Number(page));
    console.log({ currentApi, initialOffset, finalOffset });
    setElementos(currentApi?.listaEndpoints.slice(initialOffset, finalOffset));
  };

  const handleSelectApi = (api: ApiI) => {
    setCurrentApi(api);
    setElementos(api.listaEndpoints.slice(0, 10));
  };

  return (
    <Container className="main-section">
      <div className="pb-5">
        <h1>Documentación API's</h1>
        <h5 className="mb-5">Desde acá podrás gestionar las normativas.</h5>

        <Row>
          {listaApis.map((ctApi) => (
            <Col className="d-grid" key={ctApi.titulo}>
              <div className={`api-card ${ctApi.disabled ? "disabled" : ""}`}>
                <div className="api-image"></div>
                <div className="api-text">
                  <h3>{ctApi.titulo}</h3>
                  <p className="mt-2 flex-grow-1">{ctApi.descripcion}</p>
                  <Button
                    disabled={ctApi.disabled}
                    variant="link"
                    className="mx-auto"
                    onClick={() => handleSelectApi(ctApi)}
                  >
                    Ver API
                  </Button>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
      {currentApi && elementos && (
        <>
          <div className="d-flex justify-content-between align-items-end mt-5 mb-3 ">
            <h2>{currentApi.titulo}</h2>
            {currentApi.swaggerDocs && (
              <div className="mb-2">
                <a
                  href={currentApi.swaggerDocs}
                  className="with-icon gap-1"
                  target="_blank"
                >
                  <FileIcon /> Ver documentación
                </a>
              </div>
            )}
          </div>
          <EndpointsTable elementos={elementos} />
          <Pagination
            totalItems={currentApi.listaEndpoints.length}
            currentPage={page}
            onChangePage={handleChangePage}
            showLimitSelect={false}
          />
        </>
      )}
    </Container>
  );
};
